import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createRally,
  createRallyPricings,
  deleteRally,
  getAllRallies,
  getRallyById,
  updateRally,
} from "./rally.service";

export const useGetRallies = () => {
  return useQuery({
    queryKey: ["rallies"],
    queryFn: getAllRallies,
  });
};

export const useGetRallyById = (rallyId) => {
  return useQuery({
    queryKey: ["rallies", rallyId],
    queryFn: () => getRallyById(rallyId),
    enabled: Boolean(rallyId),
  });
};

export const useCreateRallyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createRally,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rallies"] });
    },
  });
};

export const useUpdateRallyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ rallyId, rallyData }) => updateRally(rallyId, rallyData),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["rallies"] });
      if (variables?.rallyId) {
        queryClient.invalidateQueries({ queryKey: ["rallies", variables.rallyId] });
      }
    },
  });
};

export const useDeleteRallyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteRally,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rallies"] });
    },
  });
};

export const useCreateRallyPricingsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ eventId, prices }) => createRallyPricings(eventId, prices),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["rallies"] });
      if (variables?.eventId) {
        queryClient.invalidateQueries({
          queryKey: ["rallies", variables.eventId],
        });
      }
    },
  });
};
